import { directCall, get, post } from './api';
import routes from './end-points';

export const authenticationApi = {
  login: (dto) => post(routes.authentication.login, dto, true),
  loginByOtp: (dto) => post(routes.authentication.loginByOtp, dto, true),
  register: (dto) => post(routes.authentication.register, dto, true),
  userInfo: () => get(routes.authentication.userInfo, true),
  loginByAdmin: (userName) => post(`${routes.authentication.loginByAdmin}?userName=${userName}`, true),
  refresh: () => directCall(routes.authentication.refresh, true),
  sendOtp: (dto) => post(routes.authentication.sendOtp, dto),
};
